import React, { useState, useEffect, useContext } from "react";
import FadeIn from "react-fade-in";
import { useNavigate } from "react-router-dom";
import RecipeCard from "../../../../InterstellrComponents/RecipeCard.jsx";
import { UserContext } from "../../../../storage/contexts/UserContext.js";
import axios from "axios";
import { GET_PAGE_TITLE, GET_RECIPES } from "../../../../Routes.js";
import { generateURLOptions } from "../../../../URLOptions.js";

import { FaChevronRight } from "react-icons/fa";

const EatWell = () => {
  const { profile } = useContext(UserContext);
  const navigate = useNavigate();

  const [visible, setVisible] = useState(true);

  const [pageTitle, setPageTitle] = useState(null);
  const [recipes, setRecipes] = useState([]);

  useEffect(() => {
    getPageTitle();
    getRecipes();
  }, []);

  // Define a custom comparator function
  const compareItems = (a, b) => {
    if (a.position < b.position) {
      return -1;
    }
    if (a.position > b.position) {
      return 1;
    }
    return 0;
  };

  const getRecipes = async () => {
    await axios
      .get(GET_RECIPES, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        var data = response.data.data;

        data?.data?.forEach((obj) => {
          obj.recipes?.sort(compareItems);
        });

        setRecipes(data);
      })
      .catch((error) => {
        console.log("Get Recipe Data Error: ", error);
        return alert(error);
      });
  };

  const getPageTitle = async () => {
    await axios
      .get(GET_PAGE_TITLE + "eat_well", {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        setPageTitle(response.data?.data?.heading ?? "");
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const viewCategory = (data) => {
    console.log("Tapped Category: ", data);
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/recipes/category", {
        state: {
          categoryId: data?._id,
        },
      });
    }, 500);
  };

  const viewRecipe = (data) => {
    console.log("Tapped Recipe", data);
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/recipes/details", {
        state: {
          recipeId: data?._id,
        },
      });
    }, 500);
  };

  return (
    <>
      <div
        className="w-screen min-h-screen"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <FadeIn delay={200} visible={visible}>
          <div className="container mx-auto flex flex-col justify-center items-center h-full w-full">
            <div className="mt-12 px-6 md:px-0">
              <h4 className="text-xl md:text-2xl font-semibold">
                {pageTitle ? pageTitle : "Eat well 🍎"}
              </h4>

              {recipes?.map((eat) => (
                <div key={eat?._id} className="flex flex-col mt-4 pb-4">
                  <div className="flex flex-row justify-center items-center">
                    <h4 className="text-lg font-medium text-black">
                      {eat.name}
                    </h4>

                    <div style={{ flex: 1 }} />

                    <button
                      className="text-black font-medium text-base"
                      onClick={() => viewCategory(eat)}
                    >
                      View All {eat.name} Items
                    </button>
                    <FaChevronRight fontSize={14} className="ml-1" />
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-4 mt-6">
                    {eat.recipes.map((subItem, index) =>
                      index < 5 ? (
                        <RecipeCard
                          key={subItem._id}
                          recipe={subItem}
                          onClick={viewRecipe}
                        />
                      ) : null
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </>
  );
};

export default EatWell;
